import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Step from 'book-calculator/components/Step';
import EditingFieldset from 'book-calculator/containers/EditingFieldset';

const EditingStep = ({ step }) => (
    <Step
        step={step}
        title={<FormattedMessage id="steps.editing.heading" />}
        description={<FormattedMessage id="steps.editing.description" />}
    >
        <div className="heading heading--h4 heading--grey800">
            <FormattedMessage id="steps.editing.subheading" />
        </div>

        <EditingFieldset />
    </Step>
);

EditingStep.propTypes = {
    step: PropTypes.number.isRequired,
};

export default EditingStep;
